// Hexon ads status codes
// From https://api.sandbox.hexon.nl/autoflex/api/v1/restdoc/ads

export interface IStatus {
  [index: string]: { iconName: string; iconColor: string };
}

export default {
  WILL_BE_ADDED: {
    // text: "The vehicle will be advertised",
    iconName: "help-circle",
    iconColor: "icon-blue",
  },
  CANNOT_BE_ADDED: {
    // text: "The vehicle cannot be advertised; see errors for details",
    iconName: "close-circle",
    iconColor: "icon-red",
  },
  ADVERTISED: {
    // text: "The vehicle is advertised",
    iconName: "checkmark-circle",
    iconColor: "icon-green",
  },
  WILL_BE_UPDATED: {
    // text: "The ad will be updated",
    iconName: "help-circle",
    iconColor: "icon-blue",
  },
  CANNOT_BE_UPDATED: {
    // text: "The ad cannot be updated; see errors for details",
    iconName: "close-circle",
    iconColor: "icon-red",
  },
  WILL_BE_REMOVED: {
    // text: "The ad will be removed",
    iconName: "help-circle",
    iconColor: "icon-blue",
  },
  CANNOT_BE_REMOVED: {
    // text: "The ad cannot be removed; see errors for details",
    iconName: "close-circle",
    iconColor: "icon-red",
  },
  NOT_SELECTED: {
    // text: "The vehicle is not selected",
    iconName: "alert",
    iconColor: "icon-yellow",
  },
};



// WEBPACK FOOTER //
// ./src/providers/hexon/ad-status.ts